"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'project.name.placeholder': 'Inserisci nome del progetto',
};
